import { Microapp } from 'signup-constants/Microapp';
export const getEmailSignatureGeneratorState = state => {
  return state.microapp && state.microapp[Microapp.EmailSignatureGenerator];
};
export const getInvoiceGeneratorState = state => {
  return state.microapp && state.microapp[Microapp.InvoiceGenerator];
};